import type { TFunction } from 'i18next';
import type { SelectOption } from '@/components/ui/select';
import {
  isEstateAvailabilityCompatible,
  type EstateAvailability,
} from 'realitiq-utils/src/flatfinder';

const estateAvailabilityValues = ['available', 'reserved', 'sold', 'rented'] as const;

export const getEstateAvailabilityOptions = (t: TFunction, marketType: string): SelectOption[] => [
  { id: '', title: t('availabilityNotSpecified') },
  ...estateAvailabilityValues
    .filter((availability) => isEstateAvailabilityCompatible(availability, marketType))
    .map((availability) => ({
      id: availability,
      title: t(`availability${availability[0].toUpperCase()}${availability.slice(1)}`),
    })),
];

export const getEstateAvailabilityLabel = (t: TFunction, availability: EstateAvailability) => {
  if (!availability) return t('availabilityNotSpecified');

  return t(`availability${availability[0].toUpperCase()}${availability.slice(1)}`);
};

export type { EstateAvailability };
